import * as BenchlingUtil from 'BenchlingUtil';
import * as WindowLocationUtil from 'util/WindowLocationUtil';

/**
 * Utility for managing the tab URL parameter.
 *
 * This allows deep linking to specific tabs within a workspace view.
 * The tab parameter is updated without triggering a full page navigation.
 */

export const TAB_PARAM_NAME = 'tab';

/**
 * Gets the current tab parameter value from the URL.
 * @returns The tab parameter value, or null if not present.
 */
export function getTabParam(): string | null {
  const params = new URLSearchParams(WindowLocationUtil.getSearch());
  return params.get(TAB_PARAM_NAME);
}

/**
 * Sets the tab parameter in the URL without triggering a full page navigation.
 * Uses replaceState to avoid polluting browser history with tab changes.
 * @param tab - The tab value to set in the URL.
 */
export function setTabParam(tab: string): void {
  const url = new URL(BenchlingUtil.getLocationHref());
  url.searchParams.set(TAB_PARAM_NAME, tab);
  window.history.replaceState(window.history.state, '', url.toString());
}
